import dic from '@/assets/dictionary/index.js'
import {
  LANG,
  SOVTES_TEL,
  SOVTES_EMAIL,
  LINK_LINKEDIN,
  LINK_YOUTUBE,
  LINK_FACEBOOK,
} from '@/libs/constants'
const {
  footer: { address },
} = dic[LANG]

export const newAddress = (address) => [
  address.city,
  address.street,
  address.house,
]

export default {
  namespaced: true,
  state: {
    title: 'Sovtes',
    foundationYear: 2011,
    email: SOVTES_EMAIL,
    phone: SOVTES_TEL,
    address: newAddress(address),
    socials: {
      linkedin: LINK_LINKEDIN,
      youtube: LINK_YOUTUBE,
      facebook: LINK_FACEBOOK,
    },
  },
}
